/*
 * @Auther: 罗耀祖
 * @Date: 2022-02-09 15:38:39
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-02-09 16:06:54
 * @name: 
 * @Description: 
 * @FilePath: \preSaleNafterSaleInside\project\src\store\index.js
 * @Author: desktop
 */
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

// 导入modlues的所有模块
const modulesFiles = require.context('./modules', true, /\.js$/)

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

export default new Vuex.Store({
  state: {
    
  },
  mutations: {
    
  },
  actions: {
    
  },
  modules
})
